//eslint-disable-next-line
import { mount } from "globalNavigationReact/index";
import React, { useEffect, useState } from "react";
import { getPageLocale, convertLocaleFormat } from "../utils/helpers";

export const GlobalNavLayout = ({
    activeAppPathList,
    handleNavigate,
    children,
    readyToMountNav,
}) => {
    const [isSubNavPresent, setSubNavPresent] = useState(false);
    useEffect(() => {
        if (!readyToMountNav) {
            return;
        }
        const setSubNavPresentToBeTrue = () => {
            setSubNavPresent(true);
        };
        document.addEventListener("global-navigation:load", setSubNavPresentToBeTrue);
        mount({
            headerElemID: "account-wrapper-global-nav-container",
            footerElemID: "footer-container",
            showHeader: true,
            showFooter: true,
            headerConfig: { preventPullUp: true, showBlankMegaMenu: true },
            footerConfig: {
                showLegalFooter: true,
                showPageFooter: false,
            },
            mountLocale: convertLocaleFormat(getPageLocale(), "xx_XX"),
            mountBrand: "account",
            injectAEMfont: false,
        });
    }, [readyToMountNav]);

    useEffect(() => {
        if (!isSubNavPresent) {
            return;
        }
        const isPathActive = (itemNavPath) => {
            try {
                let splitPath = new URL(itemNavPath)?.pathname.split("/").filter(Boolean);
                //if first element is regex matching xx-xx, remove it
                if (/^[a-z]{2}-[a-z]{2}$/i.test(splitPath[0])) splitPath = splitPath.slice(1);
                //props.activeAppPathList is like ["/account/preferences", "/account/email-preferences"]
                //${splitPath.join("/")} is like '/account/preferences'
                return activeAppPathList?.includes(`/${splitPath.join("/")}`);
            } catch (error) {
                return false;
            }
        };

        const anchorTags = document
            .getElementById("global-navigation-subbrand-menu")
            ?.querySelectorAll("a");
        for (let anchorTag of anchorTags) {
            if (isPathActive(anchorTag.href)) {
                anchorTag.style.color = "#76b900";
            } else {
                anchorTag.style.removeProperty("color");
            }
            const label = anchorTag.querySelector("span")?.innerText;
            anchorTag.onclick = (e) => {
                e.preventDefault();
                handleNavigate({ url: anchorTag.href, label });
            };
        }
    }, [activeAppPathList, isSubNavPresent]);

    return (
        <div>
            <header id="main-header">
                <div id="account-wrapper-global-nav-container"></div>
            </header>
            {children}
        </div>
    );
};
